import { requestApi } from '@/utils/request'

export function getWorkflows(params) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/workflow',
    params,
  })
}

export function getWorkflow(id) {
  return requestApi({
    method: 'get',
    endpoint: `/v2/workflow/${id}`,
  })
}

export function createWorkflow(payload) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/workflow',
    data: payload,
  })
}

export function deleteWorkflow(id) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/workflow/${id}`,
  })
}

export function updateWorkflow({ id, payload }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/workflow/${id}`,
    data: payload,
  })
}

export function changeStatusWorkflow(id, payload) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/workflow/change-status/${id}`,
    data: payload,
  })
}

export function copyWorkflow(id) {
  return requestApi({
    method: 'post',
    endpoint: `/v2/workflow/clone/${id}`,
  })
}

export function getWorkflowHistories({ id, params }) {
  return requestApi({
    method: 'get',
    endpoint: `/v2/workflow/${id}/run-histories`,
    params,
  })
}
